import { render, staticRenderFns } from "./stat-panel.vue?vue&type=template&id=4e93cf84&scoped=true&"
import script from "./stat-panel.js?vue&type=script&lang=js&"
export * from "./stat-panel.js?vue&type=script&lang=js&"
import style0 from "./stat-panel.scss?vue&type=style&index=0&id=4e93cf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e93cf84",
  null
  
)

export default component.exports